import { useEffect, useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import classNames from "classnames";
import { Button, DropDown, Label, Typography } from "components/atoms";
import { useAddTopicFocusToCourseworkMutation } from "services/topicFocus";
import { formatToLocalDate } from "utils/functions/formatToLocalDate";
import { getObjectKeysByValue } from "services/helpers";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "components/molecules/ToolTip";
import { getTooltipContentByStatus } from "utils/functions/tooltipContentByStatus";

dayjs.extend(utc);

interface IProps {
  obj: any;
  getMatchColor: any;
  theme?: "light" | "dark";
}

export const InstructorRecord = ({ obj, getMatchColor, theme }: IProps) => {
  const [selectedOption, setSelectedOption] = useState<
    null | string | { [key: number]: string }
  >(null);

  const [addToCoursework, { isLoading }] =
    useAddTopicFocusToCourseworkMutation();

  const handleClick = async (obj: any) => {
    if (selectedOption && typeof selectedOption === "object") {
      const keyStr = Object.keys(selectedOption)[0];

      const key = parseInt(keyStr, 10);

      let filterItem = obj.NearFutureSegments.filter(
        (element: any, index: number) => {
          return index === key;
        }
      );

      try {
        await addToCoursework({
          segmentId: filterItem[0].ProductOfferingSegmentId,
          page: 1,
        }).unwrap();
      } catch (error) {
        console.log("error : ", error);
      }
    } else {
      console.error("selectedOption is not an object.");
    }
  };

  const getSubmittedClassDateStatus = (obj: any) => {
    if (obj.NearFutureSegments.length > 0) {
      const startTime = obj.NearFutureSegments.find(
        (segment: any) =>
          segment.ProductOfferingSegmentId === obj.ProductOfferingSegmentId
      );

      if (startTime) {
        return dayjs(startTime.StarttimeUTC).isValid()
          ? dayjs.utc(startTime.StarttimeUTC).local().format("MM/DD/YY")
          : startTime;
      } else {
        return "Unknown";
      }
    }
  };

  const getSubmittedInstructorStatus = (obj: any) => {
    if (obj.NearFutureSegments.length > 0) {
      const record = obj.NearFutureSegments.find(
        (segment: any) =>
          segment.ProductOfferingSegmentId === obj.ProductOfferingSegmentId
      );
      // return record.InstructorName;

      if (record) {
        return record.InstructorName;
      } else {
        return "Unknown";
      }
    }
  };

  return (
    <>
      <td
        className={classNames({
          "test-name": true,
        })}
      >
        {obj.Name}
      </td>
      {obj.NearFutureSegments &&
      Array.isArray(obj.NearFutureSegments) &&
      obj.NearFutureSegments.length > 0 ? (
        obj.IsAddedToHome === false ? (
          <td colSpan={2}>
            <DropDown
              placeholder="Select Class Date and Instructor"
              setDropDownSelection={setSelectedOption}
              defaultSelected={selectedOption}
              data={obj.NearFutureSegments.map(
                (value: any) =>
                  `${formatToLocalDate(
                    value.StarttimeUTC,
                    "MM/DD/YY h:mm A"
                  )} ${value.InstructorName}`
              )}
            />
          </td>
        ) : (
          <>
            <td>{getSubmittedClassDateStatus(obj)}</td>
            <td>{getSubmittedInstructorStatus(obj)}</td>
          </>
        )
      ) : (
        <>
          <td>
            {dayjs(obj.ClassDate).isValid()
              ? dayjs(obj.ClassDate).format("MM/DD/YY h:mm A")
              : obj.ClassDate}
          </td>
          <td>Unknown</td>
        </>
      )}
      <td>
        {dayjs(obj.TimeEntered).isValid()
          ? dayjs(obj.TimeEntered).format("MM/DD/YY h:mm A")
          : obj.TimeEntered}
      </td>
      <td
        className={classNames({
          status: true,
        })}
      >
        {obj.IsAddedToHome ? (
          <Tooltip>
            <TooltipTrigger>
              <Label
                backgroundColor={getMatchColor(obj.Status)}
                label={obj.Status}
              />
            </TooltipTrigger>
            <TooltipContent className={`status-topic-focus-tooltip-${theme}`}>
              <Typography
                variant="h8Book"
                label={getTooltipContentByStatus(obj.Status)}
              />
            </TooltipContent>
          </Tooltip>
        ) : (
          <Button
            styles="add-coursework-btn"
            icon={false}
            label="Add to Coursework"
            type="planner"
            onClick={() => handleClick(obj)}
            isLoading={isLoading}
          />
        )}
      </td>
    </>
  );
};
